// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3jqoK","range":"MonthRangeSwitch_range__2OMs-","disabled":"MonthRangeSwitch_disabled__32dem"};